<template>
	<div class="">
		<b class="">{{ formattedElapsedTime }}</b>
	</div>
</template>

<script>
export default {
	name: 'StopWatch',
	props: {
		timestamp: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			elapsedTime: 0,
			timer: undefined,
		};
	},
	mounted() {
		this.elapsedTime = this.timestamp;
		this.start();
	},
	methods: {
		start() {
			this.timer = setInterval(() => {
				this.elapsedTime += 1000;
			}, 1000);
		},
		stop() {
			clearInterval(this.timer);
		},
		reset() {
			this.elapsedTime = 0;
		},
	},
	computed: {
		formattedElapsedTime() {
			return this.days + ':' + this.hours + ':' + this.minutes + ':' + this.seconds;
		},
		days: function () {
			return Math.floor(this.elapsedTime / (1000 * 60 * 60 * 24));
		},
		hours: function () {
			return Math.floor(this.elapsedTime / 1000 / 60 / 60) % 24;
		},
		minutes: function () {
			return Math.floor(this.elapsedTime / 1000 / 60) % 60;
		},
		seconds: function () {
			return Math.floor(this.elapsedTime / 1000) % 60;
		},
		milliSeconds: function () {
			return Math.floor(this.elapsedTime % 1000);
		},
	},
	watch: {},
};
</script>

<style scoped></style>
